import { Record, Union } from "../SparePartInfo.UI/fable_modules/fable-library.3.7.12/Types.js";
import { array_type, bool_type, class_type, record_type, float64_type, option_type, int32_type, union_type, string_type } from "../SparePartInfo.UI/fable_modules/fable-library.3.7.12/Reflection.js";

export class SparePartId extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SparePartId"];
    }
}

export function SparePartId$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.SparePartId", [], SparePartId, () => [[["Item", string_type]]]);
}

export function SparePartIdModule_ofString(s) {
    return new SparePartId(0, s);
}

export function SparePartIdModule_toString(_arg1) {
    return _arg1.fields[0];
}

export class SalesListId extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SalesListId"];
    }
}

export function SalesListId$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.SalesListId", [], SalesListId, () => [[["Item", string_type]]]);
}

export function SalesListIdModule_ofString(s) {
    return new SalesListId(0, s);
}

export function SalesListIdModule_toString(_arg1) {
    return _arg1.fields[0];
}

export class ProductId extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ProductId"];
    }
}

export function ProductId$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.ProductId", [], ProductId, () => [[["Item", string_type]]]);
}

export function ProductIdModule_ofString(s) {
    return new ProductId(0, s);
}

export function ProductIdModule_toString(_arg1) {
    return _arg1.fields[0];
}

export class ProjectId extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ProjectId"];
    }
}

export function ProjectId$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.ProjectId", [], ProjectId, () => [[["Item", string_type]]]);
}

export function ProjectIdModule_ofString(s) {
    return new ProjectId(0, s);
}

export function ProjectIdModule_toString(_arg1) {
    return _arg1.fields[0];
}

export class Battery extends Record {
    constructor(IECCode, BATTKZ, Battchargetype, Battmatcomp, Battdef1, Manufacturer, LIContent, CapperBatt, BATTCELLS, Battweight, BattweightUnit) {
        super();
        this.IECCode = IECCode;
        this.BATTKZ = BATTKZ;
        this.Battchargetype = Battchargetype;
        this.Battmatcomp = Battmatcomp;
        this.Battdef1 = Battdef1;
        this.Manufacturer = Manufacturer;
        this.LIContent = LIContent;
        this.CapperBatt = CapperBatt;
        this.BATTCELLS = BATTCELLS;
        this.Battweight = Battweight;
        this.BattweightUnit = BattweightUnit;
    }
}

export function Battery$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.Battery", [], Battery, () => [["IECCode", string_type], ["BATTKZ", string_type], ["Battchargetype", string_type], ["Battmatcomp", string_type], ["Battdef1", string_type], ["Manufacturer", string_type], ["LIContent", string_type], ["CapperBatt", string_type], ["BATTCELLS", option_type(int32_type)], ["Battweight", option_type(float64_type)], ["BattweightUnit", string_type]]);
}

export class Jpdm extends Record {
    constructor(OrderPartNumber, Manufacturer, ModelNo, ProductNo) {
        super();
        this.OrderPartNumber = OrderPartNumber;
        this.Manufacturer = Manufacturer;
        this.ModelNo = ModelNo;
        this.ProductNo = ProductNo;
    }
}

export function Jpdm$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.Jpdm", [], Jpdm, () => [["OrderPartNumber", string_type], ["Manufacturer", string_type], ["ModelNo", string_type], ["ProductNo", string_type]]);
}

export class P84 extends Record {
    constructor(MaterialNo, Description, SalesText, Vmsta_01, Vmsta_31, JpdmMmsta, P84Mmsta, OrderableFrom, DeliverableFrom, LimitedAvailability, EolControlDate) {
        super();
        this.MaterialNo = MaterialNo;
        this.Description = Description;
        this.SalesText = SalesText;
        this.Vmsta_01 = Vmsta_01;
        this.Vmsta_31 = Vmsta_31;
        this.JpdmMmsta = JpdmMmsta;
        this.P84Mmsta = P84Mmsta;
        this.OrderableFrom = OrderableFrom;
        this.DeliverableFrom = DeliverableFrom;
        this.LimitedAvailability = LimitedAvailability;
        this.EolControlDate = EolControlDate;
    }
}

export function P84$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.P84", [], P84, () => [["MaterialNo", string_type], ["Description", string_type], ["SalesText", string_type], ["Vmsta_01", string_type], ["Vmsta_31", string_type], ["JpdmMmsta", string_type], ["P84Mmsta", string_type], ["OrderableFrom", option_type(class_type("System.DateTime"))], ["DeliverableFrom", option_type(class_type("System.DateTime"))], ["LimitedAvailability", string_type], ["EolControlDate", option_type(class_type("System.DateTime"))]]);
}

export class SparePartChainLink extends Record {
    constructor(MaterialNo, B0MAT, SUBMAT, BISMAT) {
        super();
        this.MaterialNo = MaterialNo;
        this.B0MAT = B0MAT;
        this.SUBMAT = SUBMAT;
        this.BISMAT = BISMAT;
    }
}

export function SparePartChainLink$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.SparePartChainLink", [], SparePartChainLink, () => [["MaterialNo", string_type], ["B0MAT", string_type], ["SUBMAT", string_type], ["BISMAT", string_type]]);
}

export class SparePartChain extends Record {
    constructor(ChainId, Links) {
        super();
        this.ChainId = ChainId;
        this.Links = Links;
    }
}

export function SparePartChain$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.SparePartChain", [], SparePartChain, () => [["ChainId", string_type], ["Links", class_type("System.Collections.Generic.IEnumerable`1", [SparePartChainLink$reflection()])]]);
}

export class SparePart extends Record {
    constructor(MaterialNo, PartNumber, Description, DescriptionDE, Division, ProductHierarchy, VendorPartNo, ProductCode, TechnicalInfo, ReturnCode, RepairCode, ListPrice, EndOfService, EndOfServiceMax, CreditPrice, Currency, CRU, SubstituteMaterial, AlternativePart, CentralLocal, MainAlternativePart, Engineer, Planner, DataSecurity, MS80, CommodityCode, LegalControlDE, LegalControlEN, CountryOfOrigin, RoHSKz, DangerousGoods, HazardousMaterialNumber, ArticleNumberBattery1, ArticleNumberBattery2, ExternalPackaging, InternalPackaging, ESDBag, GrossWeight, NetWeight, WeightUnit, Volume, VolumeUnit, Length, Width, Height, DimensionUnit, CriticalPart, SupplierCreditorNo, SupplierCreditorName, RepairerCreditorNo, RepairerCreditorName, RepairerPartNo, GeneralInfo, PrecheckInfo, InboundInfo, ReturnInfo, SerialNoPrefix, MaterialKind, NotInStore, MoreInfo, UseUp, LastCall, RepairOnly, CreationDate, UsedInProducts, UsedInSalesLists, Chain, Batteries, PekuniaModelNo, Jpdms, P84, Compas) {
        super();
        this.MaterialNo = MaterialNo;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.DescriptionDE = DescriptionDE;
        this.Division = Division;
        this.ProductHierarchy = ProductHierarchy;
        this.VendorPartNo = VendorPartNo;
        this.ProductCode = ProductCode;
        this.TechnicalInfo = TechnicalInfo;
        this.ReturnCode = ReturnCode;
        this.RepairCode = RepairCode;
        this.ListPrice = ListPrice;
        this.EndOfService = EndOfService;
        this.EndOfServiceMax = EndOfServiceMax;
        this.CreditPrice = CreditPrice;
        this.Currency = Currency;
        this.CRU = CRU;
        this.SubstituteMaterial = SubstituteMaterial;
        this.AlternativePart = AlternativePart;
        this.CentralLocal = CentralLocal;
        this.MainAlternativePart = MainAlternativePart;
        this.Engineer = Engineer;
        this.Planner = Planner;
        this.DataSecurity = DataSecurity;
        this.MS80 = MS80;
        this.CommodityCode = CommodityCode;
        this.LegalControlDE = LegalControlDE;
        this.LegalControlEN = LegalControlEN;
        this.CountryOfOrigin = CountryOfOrigin;
        this.RoHSKz = RoHSKz;
        this.DangerousGoods = DangerousGoods;
        this.HazardousMaterialNumber = HazardousMaterialNumber;
        this.ArticleNumberBattery1 = ArticleNumberBattery1;
        this.ArticleNumberBattery2 = ArticleNumberBattery2;
        this.ExternalPackaging = ExternalPackaging;
        this.InternalPackaging = InternalPackaging;
        this.ESDBag = ESDBag;
        this.GrossWeight = GrossWeight;
        this.NetWeight = NetWeight;
        this.WeightUnit = WeightUnit;
        this.Volume = Volume;
        this.VolumeUnit = VolumeUnit;
        this.Length = Length;
        this.Width = Width;
        this.Height = Height;
        this.DimensionUnit = DimensionUnit;
        this.CriticalPart = CriticalPart;
        this.SupplierCreditorNo = SupplierCreditorNo;
        this.SupplierCreditorName = SupplierCreditorName;
        this.RepairerCreditorNo = RepairerCreditorNo;
        this.RepairerCreditorName = RepairerCreditorName;
        this.RepairerPartNo = RepairerPartNo;
        this.GeneralInfo = GeneralInfo;
        this.PrecheckInfo = PrecheckInfo;
        this.InboundInfo = InboundInfo;
        this.ReturnInfo = ReturnInfo;
        this.SerialNoPrefix = SerialNoPrefix;
        this.MaterialKind = MaterialKind;
        this.NotInStore = NotInStore;
        this.MoreInfo = MoreInfo;
        this.UseUp = UseUp;
        this.LastCall = LastCall;
        this.RepairOnly = RepairOnly;
        this.CreationDate = CreationDate;
        this.UsedInProducts = (UsedInProducts | 0);
        this.UsedInSalesLists = (UsedInSalesLists | 0);
        this.Chain = Chain;
        this.Batteries = Batteries;
        this.PekuniaModelNo = PekuniaModelNo;
        this.Jpdms = Jpdms;
        this.P84 = P84;
        this.Compas = Compas;
    }
}

export function SparePart$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.SparePart", [], SparePart, () => [["MaterialNo", SparePartId$reflection()], ["PartNumber", string_type], ["Description", string_type], ["DescriptionDE", string_type], ["Division", string_type], ["ProductHierarchy", string_type], ["VendorPartNo", string_type], ["ProductCode", string_type], ["TechnicalInfo", class_type("System.Collections.Generic.IEnumerable`1", [string_type])], ["ReturnCode", string_type], ["RepairCode", string_type], ["ListPrice", option_type(float64_type)], ["EndOfService", option_type(class_type("System.DateTime"))], ["EndOfServiceMax", option_type(class_type("System.DateTime"))], ["CreditPrice", option_type(float64_type)], ["Currency", string_type], ["CRU", bool_type], ["SubstituteMaterial", string_type], ["AlternativePart", string_type], ["CentralLocal", string_type], ["MainAlternativePart", string_type], ["Engineer", string_type], ["Planner", string_type], ["DataSecurity", string_type], ["MS80", option_type(class_type("System.DateTime"))], ["CommodityCode", string_type], ["LegalControlDE", string_type], ["LegalControlEN", string_type], ["CountryOfOrigin", string_type], ["RoHSKz", string_type], ["DangerousGoods", string_type], ["HazardousMaterialNumber", string_type], ["ArticleNumberBattery1", string_type], ["ArticleNumberBattery2", string_type], ["ExternalPackaging", string_type], ["InternalPackaging", string_type], ["ESDBag", string_type], ["GrossWeight", option_type(float64_type)], ["NetWeight", option_type(float64_type)], ["WeightUnit", string_type], ["Volume", option_type(float64_type)], ["VolumeUnit", string_type], ["Length", option_type(float64_type)], ["Width", option_type(float64_type)], ["Height", option_type(float64_type)], ["DimensionUnit", string_type], ["CriticalPart", option_type(bool_type)], ["SupplierCreditorNo", string_type], ["SupplierCreditorName", string_type], ["RepairerCreditorNo", string_type], ["RepairerCreditorName", string_type], ["RepairerPartNo", string_type], ["GeneralInfo", class_type("System.Collections.Generic.IEnumerable`1", [string_type])], ["PrecheckInfo", class_type("System.Collections.Generic.IEnumerable`1", [string_type])], ["InboundInfo", class_type("System.Collections.Generic.IEnumerable`1", [string_type])], ["ReturnInfo", class_type("System.Collections.Generic.IEnumerable`1", [string_type])], ["SerialNoPrefix", string_type], ["MaterialKind", string_type], ["NotInStore", bool_type], ["MoreInfo", bool_type], ["UseUp", bool_type], ["LastCall", bool_type], ["RepairOnly", bool_type], ["CreationDate", option_type(class_type("System.DateTime"))], ["UsedInProducts", int32_type], ["UsedInSalesLists", int32_type], ["Chain", option_type(SparePartChain$reflection())], ["Batteries", class_type("System.Collections.Generic.IEnumerable`1", [Battery$reflection()])], ["PekuniaModelNo", option_type(string_type)], ["Jpdms", class_type("System.Collections.Generic.IEnumerable`1", [Jpdm$reflection()])], ["P84", option_type(P84$reflection())], ["Compas", class_type("System.Collections.Generic.IEnumerable`1", [string_type])]]);
}

export class SalesList extends Record {
    constructor(MaterialNo, PartNumber, Description, UsedInSpareParts, UsedInProducts) {
        super();
        this.MaterialNo = MaterialNo;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.UsedInSpareParts = (UsedInSpareParts | 0);
        this.UsedInProducts = (UsedInProducts | 0);
    }
}

export function SalesList$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.SalesList", [], SalesList, () => [["MaterialNo", SalesListId$reflection()], ["PartNumber", string_type], ["Description", string_type], ["UsedInSpareParts", int32_type], ["UsedInProducts", int32_type]]);
}

export class Product extends Record {
    constructor(MaterialNo, ProductNo, PartNumber, Description, DescriptionDE, ProductGroupPlant, ProductHierarchy, EndOfService, CRU, CentralLocal, PlanningInformation, EndOfServiceMax, Engineer, EXTWG, MS80, CreationDate, UsedInSpareParts, UsedInSalesLists, UsedInProjects) {
        super();
        this.MaterialNo = MaterialNo;
        this.ProductNo = ProductNo;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.DescriptionDE = DescriptionDE;
        this.ProductGroupPlant = ProductGroupPlant;
        this.ProductHierarchy = ProductHierarchy;
        this.EndOfService = EndOfService;
        this.CRU = CRU;
        this.CentralLocal = CentralLocal;
        this.PlanningInformation = PlanningInformation;
        this.EndOfServiceMax = EndOfServiceMax;
        this.Engineer = Engineer;
        this.EXTWG = EXTWG;
        this.MS80 = MS80;
        this.CreationDate = CreationDate;
        this.UsedInSpareParts = (UsedInSpareParts | 0);
        this.UsedInSalesLists = (UsedInSalesLists | 0);
        this.UsedInProjects = (UsedInProjects | 0);
    }
}

export function Product$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.Product", [], Product, () => [["MaterialNo", ProductId$reflection()], ["ProductNo", string_type], ["PartNumber", string_type], ["Description", string_type], ["DescriptionDE", string_type], ["ProductGroupPlant", string_type], ["ProductHierarchy", string_type], ["EndOfService", option_type(class_type("System.DateTime"))], ["CRU", bool_type], ["CentralLocal", string_type], ["PlanningInformation", array_type(string_type)], ["EndOfServiceMax", option_type(class_type("System.DateTime"))], ["Engineer", string_type], ["EXTWG", string_type], ["MS80", option_type(class_type("System.DateTime"))], ["CreationDate", option_type(class_type("System.DateTime"))], ["UsedInSpareParts", int32_type], ["UsedInSalesLists", int32_type], ["UsedInProjects", int32_type]]);
}

export class Project extends Record {
    constructor(MaterialNo, ProductNo, PartNumber, Description, DescriptionDE, ProductGroupPlant, ProductHierarchy, EndOfService, EndOfServiceMax, Engineer, UsedInProducts) {
        super();
        this.MaterialNo = MaterialNo;
        this.ProductNo = ProductNo;
        this.PartNumber = PartNumber;
        this.Description = Description;
        this.DescriptionDE = DescriptionDE;
        this.ProductGroupPlant = ProductGroupPlant;
        this.ProductHierarchy = ProductHierarchy;
        this.EndOfService = EndOfService;
        this.EndOfServiceMax = EndOfServiceMax;
        this.Engineer = Engineer;
        this.UsedInProducts = (UsedInProducts | 0);
    }
}

export function Project$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.CommonTypes.Project", [], Project, () => [["MaterialNo", ProjectId$reflection()], ["ProductNo", string_type], ["PartNumber", string_type], ["Description", string_type], ["DescriptionDE", string_type], ["ProductGroupPlant", string_type], ["ProductHierarchy", string_type], ["EndOfService", option_type(class_type("System.DateTime"))], ["EndOfServiceMax", option_type(class_type("System.DateTime"))], ["Engineer", string_type], ["UsedInProducts", int32_type]]);
}

